import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'
import { app, FCM_VAPID_KEY } from './app'
import { api } from '@/lib/api/endpoints'
import { getMachineId } from '@/lib/device'
import { emitPushMessage, type PushMessage } from '@/lib/push/messages'

// Survives HMR re-evaluation of this module: token registration and the
// onMessage handler must only be set up once per page load.
const state = globalThis as unknown as { __voypMessagingInit?: boolean }

/**
 * Register the FCM service worker, obtain a token, register the device with
 * the API, and forward foreground messages to the push emitter.
 * Call only after notification permission is granted.
 */
export async function initMessaging(): Promise<void> {
  if (state.__voypMessagingInit) return
  if (!(await isSupported().catch(() => false))) {
    console.warn('FCM not supported in this browser')
    return
  }

  const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
  const messaging = getMessaging(app)

  const token = await getToken(messaging, {
    vapidKey: FCM_VAPID_KEY,
    serviceWorkerRegistration: registration,
  })

  await api.updateProfile({
    fcm: token,
    device: 'web',
    device_version: 3,
    device_id: getMachineId(),
  })

  onMessage(messaging, (payload) => {
    try {
      console.log('MESSAGE', payload)
      if (payload.data?.message) {
        emitPushMessage(JSON.parse(payload.data.message) as PushMessage)
      }
    } catch (error) {
      console.error('bad push payload', error)
    }
  })

  state.__voypMessagingInit = true
}
